'use strict';

angular.module('imagetrend.components')
    .directive('hlpElavon', ['$q', '$window', '$filter', '$rootScope', 'Payments', 'Regions', 'Resource', 'Format', function ($q, $window, $filter, $rootScope, Payments, Regions, Resource, Format) {
        return {
            restrict: 'AE',
            scope: {
                licenseRequestId: '@'
            },
            replace: true,
            transclude: true,
            templateUrl: 'templates/elavon/elavon.html',
            controller: ['$scope', '$timeout', function ($scope, $timeout) {
                // scope functions
                $scope.pay = function () {
                    if ($scope.submitting == false) {
                        $scope.submitting = true;
                        if ($scope.directPayment) {
                            $scope.copyBilling($scope.directPaymentObject);
                            $scope.directPaymentObject.transaction_license_requests = $scope.checkout_items_ids;
                            $scope.directPaymentObject.payment_method = $scope.payment.payment_method_id;
                            $scope.regions.forEach(function (region) {
                                if (region.id === $scope.directPaymentObject.billing_region_id) {
                                    $scope.directPaymentObject.billing_region_name = region.name;
                                }
                                if (region.id === $scope.directPaymentObject.shipping_region_id) {
                                    $scope.directPaymentObject.shipping_region_name = region.name;
                                }
                            });

                            var directPayment = angular.copy($scope.directPaymentObject);
                            Payments.directPayment(directPayment).then(function (data) {
                                var transactionID = "";
                                var message = "";

                                if (data != undefined) {
                                    transactionID = data.transactionid;
                                    message = data.message;
                                }

                                if (!$scope.isPortal) {
                                    top.location.href = $rootScope.internalURL + 'license/controller.cfm?method=cnt_transactions.transactionRedirect&message=' + message + '&transactionID=' + transactionID;
                                }
                            });
                        }
                        else {
                            $scope.regions.forEach(function (region) {
                                if (region.id === $scope.payment.billing_region_id) {
                                    $scope.payment.billing_region_name = region.name;
                                }
                                if (region.id === $scope.payment.shipping_region_id) {
                                    $scope.payment.shipping_region_name = region.name;
                                }
                            });

                            // exp date is input as a MM-YYYY string and we need to send MMYY
                            var expDateSplitArray = $scope.payment.ssl_exp_date.split('-')
                            var shortenedExpDate = expDateSplitArray[0] + expDateSplitArray[1].slice(2);
                            var copyPayment = angular.copy($scope.payment);
                            copyPayment.ssl_exp_date = shortenedExpDate;

                            $scope.saveElavonObject = {};
                            $scope.saveElavonObject.mypayment = copyPayment;
                            $scope.saveElavonObject.mytotals = $scope.totals;

                            Payments.payElavon($scope.saveElavonObject).then(function (data) {

                                var transactionID = "";
                                var message = "";

                                if (data != undefined) {
                                    transactionID = data.transactionid;
                                    message = data.message;
                                }

                                if (!$scope.isPortal) {
                                    top.location.href = $rootScope.internalURL + 'license/controller.cfm?method=cnt_transactions.transactionRedirect&message=' + message + '&transactionID=' + transactionID;
                                }
                                else {
                                    top.location.href = $rootScope.portalURL + "controller.cfm?method=public.transactionRedirect&message=";
                                }
                            });
                        }
                    }
                }

                $scope.changeMethod = function (methodId) {
                    $scope.paymentMethods.forEach(function (opt) {
                        if (opt.id == methodId) {
                            $scope.paymentMethodName = opt.value;
                            $scope.selectedMethod = opt;
                            if (!$scope.directPayment) {
                                $scope.payment.ssl_payment_type = $scope.selectedMethod.payment_provider_key;
                                $scope.payment.payment_method_id = opt.id;
                            }
                        }
                    });
                }

                $scope.copyBilling = function () {
                    if ($scope.directPaymentObject.same_as_billing) {
                        $scope.directPaymentObject.shipping_street = $scope.directPaymentObject.billing_street;
                        $scope.directPaymentObject.shipping_street_2 = $scope.directPaymentObject.billing_street_2;
                        $scope.directPaymentObject.shipping_municipality = $scope.directPaymentObject.billing_municipality;
                        $scope.directPaymentObject.shipping_region_id = $scope.directPaymentObject.billing_region_id;
                        $scope.directPaymentObject.shipping_postal_code = $scope.directPaymentObject.billing_postal_code;
                    }
                }

                $scope.toggleDirectPayment = function (directPayment) {
                    if (directPayment) {
                        $scope.paymentMethods = directPaymentMethods;
                    }
                    else {
                        $scope.paymentMethods = nonDirectPaymentMethods;
                    }
                    $scope.selected_name = '';
                    $scope.payment.payment_method = undefined;
                    $scope.paymentMethodName = "";
                }

                $scope.checkPaymentType = function (options) {
                    if ($scope.paymentMethodName == undefined || $scope.paymentMethodName == "") { return false; }
                    return options.indexOf($scope.paymentMethodName) >= 0;
                }

                $scope.changeDirect = function (newValue) {
                    if (newValue) {
                        $scope.paymentMethods = $scope.directPaymentMethods;
                    }
                    else {
                        $scope.paymentMethods = $scope.nonDirectPaymentMethods;
                    }
                    $scope.directPayment = newValue;
                    $scope.selected_name = '';
                    $scope.payment.payment_method = undefined;
                }

                $scope.back = function () {
                    var url = $rootScope.internalURL + 'license/applications/billing/show.cfm?licenseRequestID=' + $scope.licenseRequestId;
                    if ($scope.isPortal) {
                        $window.history.back();
                    }
                    else {
                        $window.location.replace(url);
                    }
                }

                $scope.columnClick = function (isInspections, predicate) {
                    if (isInspections) {
                        $scope.inspectionPred = predicate;
                        $scope.inspectionRev = !$scope.inspectionRev;
                    }
                    else {
                        $scope.requestPred = predicate;
                        $scope.requestRev = !$scope.requestRev;
                    }
                }
            }],
            link: function (scope, elem, attrs, ctrl) {

                // scope variables
                scope.loading = true;
                scope.submitting = false;
                scope.paying = false;
                scope.items = [];
                scope.paymentMethods = [];
                scope.directPaymentMethods = [];
                scope.nonDirectPaymentMethods = [];
                scope.selectedMethod = {};
                scope.paymentMethodName = "";
                scope.directPayment = false;
                scope.checkingAccountTypes = [];
                scope.regions = [];
                scope.sum_balance_due = 0;
                scope.isPortal = true;
                scope.enterpriseWebsite = "";
                scope.enterpriseSiteLocation = "";

                if ($rootScope.enterprise) {
                    scope.isPortal = $rootScope.isPortal == 'True';
                    scope.enterpriseWebsite = $rootScope.enterprise.website;
                    scope.enterpriseSiteLocation = $rootScope.enterprise.site_location;
                }

                scope.directPaymentObject = {
                    internal: !scope.isPortal,
                    user_id: $rootScope.userID,
                    enterprise_id: $rootScope.enterpriseID,
                    amount: 0
                };

                scope.payment = {
                    payment_method_id: '',
                    ssl_transaction_type: 'ccsale', //authorizes transaction and is immediately submitted for settlement
                    ssl_amount: 0,
                    ssl_country: 'USA',
                    ssl_card_type: 'CREDITCARD',
                    ssl_first_name: '',
                    ssl_last_name: '',
                    ssl_email: '',
                    ssl_phone: '',
                    ssl_avs_address: '',
                    ssl_city: '',
                    ssl_state: ''
                };

                scope.requestColumns = [
                    { header: 'License', predicate: 'license_name' },
                    { header: 'Amount', predicate: 'balance_due' }
                ];
                scope.requestPred = 'license_name';

                // initial loading
                var init = function () {
                    var promises = [];

                    promises.push(Payments.getPaymentMethods().then(function (methods) {
                        if (methods != null) {

                            // scope.paymentMethods = methods;
                            scope.directPaymentMethods = methods.filter(function (method) {
                                return method.direct_payment;
                            });
                            scope.nonDirectPaymentMethods = methods.filter(function (method) {
                                return !method.direct_payment;
                            });

                            // init to non-direct
                            scope.paymentMethods = scope.nonDirectPaymentMethods;
                        }
                    }));

                    // this makes a call to Payments that looks at a session data set in CF code to determine which license requests were selected for payment
                    // see initiate_transaction.cfm for CF code
                    //for bulk pay, see PublicPortalService.cfc checkPaymentAmount

                    promises.push(Payments.GetSessionDataForPayment().then(function (items) {
                        scope.checkout_items_ids = "";
                        scope.bulkPayLicenseData = {}

                        if (items != null) {
                            if (items.hasOwnProperty('data')) {
                                if (items["data"].hasOwnProperty('checkout_items_ids')) {

                                    scope.checkout_items_ids = items["data"]["checkout_items_ids"].toString();
                                    if (scope.checkout_items_ids != null) {

                                        if (items["data"].hasOwnProperty('bulkpaylicensedata') && items["data"]["bulkpaylicensedata"].recordcount > 0) {
                                            var bulkpaylicensedataObj = items["data"]["bulkpaylicensedata"];
                                            scope.totals = [];
                                            scope.payment.ssl_amount = 0;

                                            var i;
                                            for (i = 1; i <= bulkpaylicensedataObj.recordcount; i++) {
                                                scope.totals.push(bulkpaylicensedataObj[i]);
                                            }

                                            scope.totals.forEach(function (total) {
                                                scope.payment.ssl_amount += parseFloat(total.balance_due);
                                            });

                                            scope.payment.ssl_amount = parseFloat(scope.payment.ssl_amount).toFixed(2);
                                            scope.directPaymentObject.amount = scope.payment.ssl_amount;
                                        } else {
                                            promises.push(Payments.getLicenseRequestTotals(scope.checkout_items_ids).then(function (totals) {
                                                scope.payment.transaction_license_requests = scope.items;
                                                scope.totals = totals ? totals : [];
                                                scope.payment.amount = 0;

                                                scope.totals.forEach(function (total) {
                                                    scope.payment.ssl_amount += parseFloat(total.balance_due);
                                                });
                                                scope.payment.ssl_amount = parseFloat(scope.payment.ssl_amount).toFixed(2);
                                                scope.directPaymentObject.amount = scope.payment.ssl_amount;
                                            }));
                                        }
                                    }
                                }
                            }
                        }
                    }));

                    promises.push(Payments.getCheckingAccountTypes().then(function (results) {
                        if (results != null) {
                            scope.checkingAccountTypes = results;
                        }
                    }));

                    promises.push(Payments.getCreditCardTypes().then(function (results) {
                        if (results != null) {
                            scope.creditCardTypes = results;
                        }
                    }));

                    promises.push(Payments.getDebitCardTypes().then(function (results) {
                        if (results != null) {
                            scope.debitCardTypes = results;
                        }
                    }));

                    promises.push(Regions.GetAbbreviation().then(function (regions) {
                        scope.regions = regions;
                    }));

                    $q.all(promises).then(function () {
                        scope.loading = false;
                    }).catch(function (response) {
                        // handle error
                    });
                }
                init();
            }
        };
    }])

    ;